import { render, staticRenderFns } from "./bgContain2.vue?vue&type=template&id=591fb7d0&scoped=true&"
import script from "./bgContain2.vue?vue&type=script&lang=js&"
export * from "./bgContain2.vue?vue&type=script&lang=js&"
import style0 from "./bgContain2.vue?vue&type=style&index=0&id=591fb7d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591fb7d0",
  null
  
)

component.options.__file = "bgContain2.vue"
export default component.exports